import type { Catalog } from '..'

export const automations: Catalog['automations'] = {
  statusRunning: 'em execução',
  statusOk: 'ok',
  statusFailed: 'falhou',
  connected: 'conectado',
  notConnected: 'não conectado',
  disconnect: 'Desconectar',
  connect: 'Conectar',
  reconnect: 'Reconectar',
  runTime: '{day} · {time}',

  scheduleDaily: 'Todo dia',
  scheduleWeekdays: 'Dias úteis',
  scheduleWeekly0: 'Todo domingo',
  scheduleWeekly1: 'Toda segunda-feira',
  scheduleWeekly2: 'Toda terça-feira',
  scheduleWeekly3: 'Toda quarta-feira',
  scheduleWeekly4: 'Toda quinta-feira',
  scheduleWeekly5: 'Toda sexta-feira',
  scheduleWeekly6: 'Todo sábado',
  scheduleWhenTime: '{when}, {time}',

  incompleteApprovalCanvas: 'Escolha um canvas para acompanhar as aprovações',
  incompleteAddStep: 'Adicione uma etapa',
  incompleteStepCanvas: 'Escolha um canvas para cada etapa',
  incompleteMetaAccount: 'Escolha uma conta de anúncios da Meta',
  incompleteAgentPrompt: 'Escreva o que o agente deve fazer',
  incompleteSlackChannel: 'Informe o ID de um canal do Slack',
  incompleteSlackMessage: 'Escreva uma mensagem para o Slack',
  incompleteLinearTeam: 'Escolha um time do Linear',
  incompleteLinearTitle: 'Escreva o título do ticket do Linear',
  incompleteWatchPage: 'Informe a página a observar',
  incompletePosthogPage: 'Informe a página a ler no PostHog',
  incompletePageAddress: 'Isso não parece um endereço de página',

  exampleApprovedSizesName: 'Criar outros tamanhos',
  exampleApprovedSizesBlurb: 'Adapte designs aprovados em rascunhos quadrados, verticais e horizontais.',
  exampleApprovedLocalizationName: 'Localizar designs aprovados',
  exampleApprovedLocalizationBlurb: 'Traduza designs aprovados e adapte os layouts.',
  exampleApprovedAssetsName: 'Criar peças complementares',
  exampleApprovedAssetsBlurb: 'Transforme uma direção aprovada em um conjunto de campanha.',
  exampleWeeklyCreativesName: 'Criativos semanais',
  exampleWeeklyCreativesBlurb: 'Traga todo anúncio ativo da Meta para um canvas toda segunda-feira.',
  exampleAdVariantsName: 'Variações de anúncios',
  exampleAdVariantsBlurb: 'Traga os criativos da semana e peça ao Doop cinco variações de cada um.',
  exampleFridayUxName: 'Revisão de UX de sexta',
  exampleFridayUxBlurb: 'O UX Lead revisa tudo o que mudou nesta semana.',
  exampleBrandA11yName: 'Checagem de marca e acessibilidade',
  exampleBrandA11yBlurb: 'Deixe todo frame de volta na marca e dentro do WCAG AA.',
  exampleCopyPassName: 'Revisão semanal de texto',
  exampleCopyPassBlurb: 'O Copywriter enxuga cada título e rótulo.',
  exampleNightlyPolishName: 'Acabamento noturno',
  exampleNightlyPolishBlurb: 'O Visual Polish arruma espaçamento e alinhamento toda noite.',
  examplePosthogFrustrationName: 'Corrija o que frustra os visitantes',
  examplePosthogFrustrationBlurb:
    'Quando os rage clicks em uma página sobem, o Doop rascunha uma correção a partir dos dados.',
  examplePosthogWeeklyName: 'Redesign semanal guiado por dados',
  examplePosthogWeeklyBlurb: 'Lê os insights do PostHog de uma página toda segunda e rascunha o que os números pedem.',

  roleBlurbDoop: 'Designer generalista — faz a coisa acontecer',
  roleBlurbUx: 'Fluxo, hierarquia, estados, affordances',
  roleBlurbCopy: 'Títulos, microtexto, rótulos, CTAs',
  roleBlurbBrand: 'Paleta, tipografia, logo, tom de voz',
  roleBlurbA11y: 'Contraste, semântica, foco, área de toque',
  roleBlurbPolish: 'Ritmo de espaçamento, alinhamento, detalhe final',

  newAutomation: 'Nova automação',
  newAutomationPlus: '+ Nova automação',
  createFailed: 'Não foi possível criar a automação',
  saveFailed: 'Não foi possível salvar',
  deleteFailed: 'Não foi possível excluir',
  emptyTitle: 'Nada roda sozinho ainda',
  emptyDescription:
    'Rode em um agendamento ou quando designs forem aprovados. Crie variações, repasse tickets e compartilhe novidades.',
  columnAutomation: 'Automação',
  columnCanvas: 'Canvas',
  columnLastRun: 'Última execução',
  columnNextRun: 'Próxima execução',
  toggleNamed: 'Ativar ou desativar {name}',
  canvasFallback: 'Canvas',
  pickCanvas: 'Escolha um canvas',
  running: 'Em execução',
  failed: 'Falhou',
  fix: 'Corrigir',
  never: 'Nunca',
  paused: 'pausada',
  onApproval: 'na aprovação',
  finishSetup: 'conclua a configuração',
  actionsFor: 'Ações de {name}',
  deleteTitle: 'Excluir “{name}”?',
  automationFallback: 'automação',
  deleteDescription:
    'Ela para de rodar e o histórico de execuções vai junto. Os frames que ela já criou continuam nos canvases.',
  whenApprovedLower: 'quando designs forem aprovados',
  startFromExample: 'Comece por um exemplo',
  whenApproved: 'Quando designs forem aprovados',
  whenPosthog: 'Quando uma leitura do PostHog passa de um limite',
  whenPosthogLower: 'quando {reading} em {page} passa de {line}',
  watching: 'observando',
  use: 'Usar',

  untitledAutomation: 'Automação sem título',
  on: 'Ativada',
  off: 'Desativada',
  automationToggle: 'Ativar ou desativar a automação',
  reasonFirst: '{reason} primeiro',
  runNowTitle: 'Executar a automação agora',
  runningEllipsis: 'Executando…',
  runNow: 'Executar agora',
  saving: 'Salvando…',
  renameFailed: 'Não foi possível renomear',
  runFailed: 'Não foi possível executar',
  missing: 'Essa automação não existe mais.',
  backToAutomations: 'Voltar às automações',
  addStep: '+ Adicionar etapa',
  reasonToTurnOn: '{reason} para ativá-la.',
  orStartFromExample: 'Ou comece por um exemplo',
  daily: 'diária',
  weekdays: 'dias úteis',
  runs: 'Execuções',
  runsLast: 'Execuções · última {time}',
  when: 'Quando',
  triggerLabel: 'Gatilho da automação',
  triggerSchedule: 'Em um agendamento',
  triggerApproval: 'Designs são aprovados',
  triggerPosthog: 'Uma leitura do PostHog passa de um limite',
  posthogWatchHint:
    'Lê a página a cada 15 minutos. No máximo uma execução por janela, com a leitura completa no briefing do agente.',
  watchPage: 'Página a observar',
  watchPagePlaceholder: 'https://exemplo.com/precos',
  watchMetric: 'Leitura',
  watchPasses: 'passa de',
  watchThreshold: 'Limite',
  watchOver: 'em',
  watchWindow: 'Janela',
  watchDays: { one: 'o último dia', other: 'os últimos {count} dias' },
  metricBounce: 'taxa de rejeição',
  metricExit: 'taxa de saída',
  metricUnread: 'visitas que saem antes da metade da página',
  metricRage: 'rage clicks',
  metricDead: 'cliques mortos',
  approvalHint:
    'Roda quando frames são marcados como prontos para dev. Aprovações próximas são agrupadas; designs gerados ficam como rascunho.',
  every: 'Repete',
  dayOption0: 'todo domingo',
  dayOption1: 'toda segunda-feira',
  dayOption2: 'toda terça-feira',
  dayOption3: 'toda quarta-feira',
  dayOption4: 'toda quinta-feira',
  dayOption5: 'toda sexta-feira',
  dayOption6: 'todo sábado',
  dayOptionWeekdays: 'em dias úteis',
  dayOptionDaily: 'todo dia',
  at: 'às',
  whichDays: 'Quais dias',
  time: 'Horário',
  canvasOn: 'em',
  canvasInto: 'para',
  canvasFor: 'de',
  chooseCanvas: 'Escolha um canvas',
  noCanvases: 'Nenhum canvas ainda',
  loadTeamsFailed: 'Não foi possível carregar os times. Verifique sua conexão com o Linear.',
  postToSlack: 'Publicar no Slack',
  createLinearTicket: 'Criar ticket no Linear',
  connectProvider: 'Conectar {name}',
  slackChannelLabel: 'ID do canal do Slack',
  slackChannelPlaceholder: 'ID do canal, ex.: C012ABCDEF',
  slackChannelHint: 'Copie o ID nos detalhes do canal do Slack e convide o @Doop para o canal.',
  slackMessageLabel: 'Mensagem do Slack',
  linearTeamLabel: 'Time do Linear',
  chooseTeam: 'Escolha um time',
  ticketTitleLabel: 'Título do ticket do Linear',
  ticketTitlePlaceholder: 'Título do ticket',
  ticketDescriptionLabel: 'Descrição do ticket do Linear',
  ticketDescriptionPlaceholder: 'O que precisa acontecer em seguida?',
  deliveryHint: 'Inclui links e resultados dos designs. Espera as tarefas de design anteriores terminarem.',
  removeStep: 'Remover etapa',
  pullMeta: 'Importar · Meta Ads',
  adCreatives: 'Criativos de anúncios',
  notConnectedYet: 'Ainda não conectado',
  connectMeta: 'Conectar Meta',
  adAccount: 'Conta de anúncios',
  whichAds: 'Quais anúncios',
  activeAds: 'Anúncios ativos',
  allAds: 'Todos os anúncios',
  agentTask: 'Tarefa do agente',
  taskTitle: 'Título da tarefa',
  untitledTask: 'Tarefa sem título',
  agentPromptPlaceholder: 'O que o agente deve fazer neste canvas?',
  picksUp: '{role} assume na hora',
  whatShouldRun: 'O que deve rodar?',
  shareResults: 'Compartilhe links e resultados dos designs das etapas anteriores.',
  metaPullBlurb: 'Traga criativos de anúncios da Meta para um canvas.',
  posthogPullBlurb: 'Leia como os visitantes usam uma página antes de um agente redesenhá-la.',
  posthogPullSubtitle: 'Insights da página',
  agentTaskBlurb: 'Passe um briefing em um canvas para o Doop, o UX Lead ou outro papel.',
  collapsePanel: 'Recolher painel',
  nextRun: 'Próxima execução',
  nextCheck: 'Próxima leitura',
  pausedTitle: 'Pausada',
  saveToSee: 'Salve para ver quando ela roda de novo.',
  waitingApprovals: 'Aguardando novas aprovações de design.',
  notScheduled: 'Sem agendamento.',
  noRunsYet: 'Nenhuma execução ainda.',
  noRunsApproval: 'Aprove designs no canvas selecionado para começar.',
  noRunsWatch: 'Uma execução começa quando a leitura passa do limite, ou execute agora com a leitura atual.',
  noRunsScheduled: 'A primeira está no agendamento.',
  noRunsFinish: 'Conclua a configuração e ative, ou execute agora.',
  nothingNew: 'Nada de novo',
  reconnectMeta: 'Reconectar Meta',
  openCanvas: 'Abrir {name}',
  canvasLower: 'canvas',
  showOlder: 'Mostrar anteriores',
  durationSeconds: '{s}s',
  durationMinutes: '{m}min {s}s',

  providerConnected: '{name} conectado.',
  metaStartFailed: 'Não foi possível iniciar a conexão com a Meta',
  disconnectFailed: 'Não foi possível desconectar',
  metaAccounts: { one: '{name} · {count} conta de anúncios', other: '{name} · {count} contas de anúncios' },
  metaPitch: 'Traga criativos de anúncios para um canvas',
  usedBy: { one: 'Usado por {count} automação', other: 'Usado por {count} automações' },
  notUsedYet: 'Ainda não usado por nenhuma automação',
  metaDisconnectCopy:
    'As automações que importam da Meta vão falhar até você conectar de novo. Os frames que já estão nos seus canvases continuam.',
  metaExpiresSoon: 'O acesso à Meta expira em breve — reconecte para manter as importações rodando.',
  metaNotConfigured: 'Não configurado neste servidor — defina META_APP_ID e META_APP_SECRET.',
  disconnectTitle: 'Desconectar {name}?',

  installFailed: 'Não foi possível instalar o Doop.',
  linearConnectFailed: 'Não foi possível conectar o Linear.',
  linearKeyReplaced: 'Chave do Linear substituída.',
  linearConnected: 'Linear conectado.',
  doopAgentIn: 'Agente do Doop · {workspace}',
  linearAccount: 'Conta do Linear',
  linearPitch: 'Delegue tickets ao agente de design do Doop',
  automaticPickup: 'Captura automática de design',
  readOnlyAccess: 'Acesso somente leitura aos tickets',
  manage: 'Gerenciar',
  manageLinear: 'Gerenciar Linear',
  connectLinear: 'Conectar Linear',
  linearLede: 'Escolha como o Doop trabalha com o seu workspace do Linear.',
  linearDelegate: 'Delegue uma issue ao Doop no Linear. O design e o link do canvas chegam automaticamente.',
  linearInstallBody:
    'Instale o Doop em um workspace do Linear que você administra. Tickets delegados criam canvases privados na sua conta do Doop e rodam na sua conta de modelo conectada ou na sua cota de tarefas. Membros do workspace que podem delegar ao Doop podem iniciar essas execuções.',
  installAgent: 'Instalar agente do Doop',
  linearNeedsApp:
    'A captura automática de design precisa de um app do Linear configurado pelo administrador deste servidor.',
  replaceKey: 'Substituir chave',
  linearKeyBefore: 'Crie uma chave de API pessoal no Linear em',
  linearKeyLink: 'Settings → Security & access',
  linearKeyAfter:
    'com acesso de leitura aos times que você quer que os agentes vejam. A chave fica guardada no servidor.',
  linearKeyLabel: 'Chave de API pessoal do Linear',
  checking: 'Verificando…',
  saveKey: 'Salvar chave',
  linearKeyStays: 'Sua chave atual continua conectada até a substituta ser verificada.',
  linearDisconnectCopy:
    'Interrompe a captura automática e o trabalho de design pendente do Linear, e remove o acesso aos tickets. Os canvases existentes continuam. Para remover o agente do Doop do Linear também, desinstale o app nas configurações do Linear.',

  slackWorkspace: 'Workspace do Slack',
  slackPitch: 'Mencione @Doop com um briefing de design',
  slackFootnote:
    'Qualquer pessoa no workspace pode mencionar @Doop; cada execução consome sua conta de modelo ou sua cota de tarefas',
  slackNeedsApp: 'Precisa de um app do Slack configurado pelo administrador deste servidor',
  installSlack: 'Instalar o Doop no Slack',
  slackDisconnectCopy:
    'Interrompe as menções a @Doop e o trabalho de design pendente do Slack neste workspace. Os canvases existentes continuam. Para remover o Doop do Slack também, desinstale o app nas configurações do workspace do Slack.',

  /* PostHog */
  continue: 'Continuar',
  posthogConnectFailed: 'Não foi possível conectar o PostHog.',
  posthogReachFailed: 'Não foi possível acessar o PostHog.',
  posthogConnected: 'PostHog conectado.',
  posthogProjectChanged: 'Projeto do PostHog alterado.',
  posthogProject: 'Projeto do PostHog',
  posthogPitch: 'Desenhe a partir do comportamento real dos visitantes',
  posthogFootnote: 'Insights de página e mapas de calor',
  changeProject: 'Trocar projeto',
  connectPosthog: 'Conectar o PostHog',
  changePosthogProject: 'Trocar o projeto do PostHog',
  posthogLede:
    'Os agentes leem como os visitantes usam uma página publicada (profundidade de rolagem, cliques, cliques de raiva, gravações que valem a pena assistir), e você pode pintar o mapa de calor de cliques sobre um frame importado.',
  posthogInstance: 'Instância do PostHog',
  posthogUsCloud: 'Nuvem dos EUA',
  posthogEuCloud: 'Nuvem da UE',
  posthogSelfHosted: 'Auto-hospedado',
  posthogAddress: 'Endereço',
  posthogKeyLabel: 'Chave de API pessoal',
  posthogKeyBefore: 'Crie uma no PostHog em',
  posthogKeyLink: 'Settings → Personal API keys',
  posthogKeyAfter:
    'com os escopos project:read e query:read. Ela fica criptografada no servidor e é usada só para as suas próprias leituras.',
  posthogProjectLabel: 'Projeto',
  posthogPickProject: 'Escolha um projeto',
  posthogDisconnectCopy:
    'Os agentes deixam de ler suas análises do PostHog e os mapas de calor deixam de aparecer. A chave é apagada do Doop; revogue-a no PostHog também se não precisar mais dela.',
}
